import * as Blockly from 'blockly/core';
import { stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['delay'] = function (block: Blockly.Block): string {
        const unit = block.getFieldValue('UNIT');
        const duration = gen.valueToCode(block, 'DURATION', 0) || '1000';

        if (unit === 'ms') return stmt(`delay(${duration})`);
        if (unit === 's') return stmt(`delay(${duration} * 1000UL)`);
        if (unit === 'us') return stmt(`delayMicroseconds(${duration})`);
        return stmt(`delayMicroseconds(${duration})`);
    };
}
